import React from 'react';
import { components } from 'react-select';

function NoOptionsMessage(props) {
    return <components.NoOptionsMessage {...props}>Ni možnosti</components.NoOptionsMessage>;
}

export default NoOptionsMessage;
